// @flow
import { CategoryType } from '@model/Category';
import { SkuType } from '@model/Sku';
import * as Yup from 'yup';
import { Model } from './Model';

export interface SubcategoryType {
    id: number;
    name: string;
    slug: string;
    default_sku: SkuType;
    category_id: number;
    category_name: string;
    category: CategoryType;
    default_sku_id: number;
    subcategory_to_repeat: number;
    published: boolean;
    page_title: string;
    meta_keywords: string;
    short_description: string;
    meta_description: string;
    description: string;
    product_title: string;
    product_image: any;
    product_image_id: number;
}

export const Subcategory = Model<SubcategoryType>('Subcategory', { endpoint: 'apparel-subcategories' })`
    id:Int;
    name:String;
    slug:String;
    description:String;
    default_sku:Any;
    category:Any;
    category_id:Int;
    default_sku_id:Int;
    subcategory_to_repeat:Int;
    published:boolean;
    page_title:String;
    meta_keywords:String;
    short_description:String;
    meta_description:String;
    product_title:String;
    product_image:Any;
    product_image_id:Int;
`;

export const SubcategoryValidation = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    category_id: Yup.string().required('Category is required'),
});
